// Auto-generated cornerstone translation for sl.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T15:18:19.985014+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Aplikacija za upravljanje konj: najboljša izbira za 2026 | EquiSight",
      description: "Primerjajte aplikacije za upravljanje konj za lastnike, hleve in rejce. Odkrijte, zakaj je EquiSight popolna aplikacija za vašega konja.",
      keywords: [
        "aplikacija za upravljanje konj",
        "aplikacija za upravljanje hleva",
        "dnevnik konj aplikacija",
        "aplikacija za upravljanje več konj",
        "aplikacija za brejost kobil",
        "aplikacija za rejo konj",
        "najboljša aplikacija za upravljanje konj",
      ],
    },
    hero: {
      eyebrow: "Pomoč pri izbiri · programska oprema za upravljanje konj",
      breadcrumbLabel: "Aplikacija za upravljanje konj",
      title: "Aplikacija za upravljanje konj: popoln vodič pri izbiri za lastnike, hleve in rejce.",
      intro: "Ne le seznam funkcij — poštena primerjava, pomoč pri izbiri in pogled na to, kaj mora aplikacija za upravljanje konj resnično znati v letu 2026. Za enega konja, za cel hlev ali za vašo rejnico.",
      pills: [
        {
          icon: "Users",
          label: "Za lastnike",
        },
        {
          icon: "Building2",
          label: "Za hleve",
        },
        {
          icon: "Baby",
          label: "Za rejce",
        },
        {
          icon: "Share2",
          label: "Za ekipe",
        },
      ],
      ctas: [
        {
          label: "Začnite brezplačno z 1 konjem",
          href: "#start",
          primary: true,
        },
        {
          label: "Na primerjalno tabelo",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Zakaj aplikacija za upravljanje konj postaja vse pomembnejša.",
      lead: "Upravljanje konj je v praksi razpršeno: WhatsApp, koledar, Excel, fotografije na telefonu, papirnati potni list, ločeni računi in ustni dogovori. Že pri enem konju nepraktično. Pri več konjih, rejnicah ali skupni oskrbi nastajajo vrzeli, zamujeni termini in nesporazumi.",
      items: [
        "Kdaj je bil spet datum cepljenja?",
        "Kdo je plačal kovaču?",
        "Katero kobilo je treba danes preveriti?",
        "Ali je trener prebral navodila iz prejšnjega tedna?",
        "Ali sem res shranil tisto fotografsko dokumentacijo?",
        "Ali je krmni urnik, ki visi v hlevu, še aktualen?",
      ],
    },
    what: {
      title: "Kaj je aplikacija za upravljanje konj?",
      lead: "Aplikacija za upravljanje konj je v bistvu digitalna mapa za vsakega konja. Nobenih razpršenih zapiskov — le eno mesto za zdravje, trening, prehrano, dokumente, načrtovanje, opomniki, stroški, fotografije, videoposnetki in skupen dostop. Vsi okoli konja gledajo na iste, aktualne informacije.",
      targetGroupsTitle: "Za koga je namenjena aplikacija za upravljanje konj?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Zasebni lastnik",
          body: "En konj, ena mapa — zdravje, načrtovanje in zgodovina v žepu.",
        },
        {
          icon: "Users",
          title: "Lastnik z več konji",
          body: "Ločeni profili, ločeno načrtovanje, skupen seznam nalog za celotno ekipo.",
        },
        {
          icon: "Building2",
          title: "Penzijonski hlev in jahalnica",
          body: "Dostop za lastnike, navodila za oskrbo, skupna agenda in naloge.",
        },
        {
          icon: "Baby",
          title: "Rejnica",
          body: "Cikel kobil, brejost, podatki o žrebcih, rodovnik in razvoj žrebet.",
        },
        {
          icon: "Target",
          title: "Trenerji",
          body: "Pregled po konju, beleženje sej, postavljanje ciljev, analiza videoposnetkov.",
        },
        {
          icon: "ClipboardList",
          title: "Strokovnjaki",
          body: "Kovač, zobozdravnik, fizioterapevt ali veterinar — delo iz iste mape.",
        },
      ],
    },
    criteria: {
      title: "Kaj mora dobra aplikacija za upravljanje konj izpolnjevati?",
      lead: "Aplikacija ni le lepa — mora delovati praktično vsak dan. Pet elementov, ki ne smejo manjkati pri izbiri za leto 2026.",
      items: [
        {
          icon: "FileText",
          title: "Mapa za vsakega konja",
          body: "Podatki, starost, pasma, informacije o potnem listu, lastnik, hlev, fotografije in dokumenti — vse povezano z enim profilom konja.",
        },
        {
          icon: "Heart",
          title: "Zdravje in nega",
          body: "Cepljenja, razčrevljanje, kovač, zobozdravnik, veterinar, zdravljenja, zdravila in avtomatski opomniki pred datumom poteka.",
        },
        {
          icon: "Activity",
          title: "Trening in napredek",
          body: "Beleženje treningov, zapiski, videoposnetki, tekmovalni rezultati, cilji in napredek po disciplini ali po konju.",
        },
        {
          icon: "Apple",
          title: "Prehrana in upravljanje",
          body: "Krmni urniki, dodatki, krma, teža, telesna kondicija in dnevna rutina, ki jo mora poznati hlev.",
        },
        {
          icon: "Share2",
          title: "Deljenje z drugimi",
          body: "Dostop za lastnika, skrbnika, trenerja, hlevarjа ali strokovnjaka — z upravljanjem pravic, ki ustreza vlogi vsakega.",
        },
        {
          icon: "Calendar",
          title: "Načrtovanje in opomniki",
          body: "Skupna agenda z nalogami, avtomatski opomniki in potrditve, da nič ne pade skozi razpoke.",
        },
      ],
    },
    comparison: {
      title: "EquiSight v primerjavi z drugimi aplikacijami za upravljanje konj.",
      lead: "Trg je trenutno zapolnjen z aplikacijami Stalmanager, LogMyHorse, EquineM in Happie Horse. Vsaka ima svoje prednosti. Najpogosteje zahtevane funkcije postavljamo eno ob drugo — pošteno in na podlagi javno dostopnih informacij.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Brezplačen začetek",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Več konj",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Zdravstvena mapa",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Trening in napredek",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Prehrana in dodatki",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Načrtovanje in opomniki",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dokumenti po konju",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Deljenje z ekipo in pravice",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Modul za rejo (popoln)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Cikel kobil",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Načrtovanje brejosti + ehografije",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Razvoj žrebet",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integracija strokovnjakov",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Vpogledi EquiCoach",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Primerno za lastnike",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Primerno za rejce",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Primerno za hlev/jahalnico",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Primerjava na podlagi javno dostopnih funkcij januarja 2026. Konkurenti so prav tako dobra orodja; EquiSight je zgrajen za združevanje vseh modulov v eni aplikaciji.",
    },
    why: {
      title: "Zakaj je EquiSight drugačen.",
      lead: "Dnevnik beleži. EquiSight združuje upravljanje konj, trening, prehrano, zdravje, tekmovanja, strokovnjake in rejo v eni sodobni aplikaciji — in gre korak dlje z vpogledi.",
      points: [
        {
          icon: "Heart",
          title: "Ena aplikacija za celotno življenje konja",
          body: "Od žrebeta do športnega konja, plemenite kobile ali upokojenega konja. Mapa raste skupaj z vašim konjem — nič se ne izgubi po poti.",
        },
        {
          icon: "Sparkles",
          title: "Ne le podatki, ampak tudi vzorci",
          body: "EquiCoach združuje razvoj, ponavljajoče se težave, trening in prehrano — da pravočasno opazite signale, ne le ločena obvestila.",
        },
        {
          icon: "Share2",
          title: "Zgrajen za sodelovanje",
          body: "Lastnik, hlevar, trener, kovač in drugi strokovnjaki delajo iz iste konjske mape — s pravicami, ki ustrezajo njihovi vlogi.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Niša · reja konj",
      title: "Upravljanje konj za rejce.",
      lead: "Mnogi konkurenti omenjajo rejo konj v eni vrstici. EquiSight je zgradil popoln modul za rejo — ker rejec redko ni končni uporabnik splošne aplikacije, a potrebuje načrtovanje bolj kot kdorkoli drug.",
      items: [
        "Dnevno spremljanje cikla kobil",
        "Datum osemenitve in podatki o žrebcu",
        "Kontrola brejosti z ehografijami",
        "Pričakovani datum žrebitve in opozorila",
        "Razvoj žrebet po mesecih",
        "Rodovnik in poreklo",
        "Zapiski po kobili",
        "Pregled vseh brejих kobil",
      ],
      ctaLabel: "Oglejte si modul za rejo",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Niša · hlev in jahalnica",
      title: "Upravljanje konj za več konj in penzijonske hleve.",
      lead: "Pri več konjih gre manj za podatke in bolj za komunikacijo. Vsak lastnik ima lastne želje, rutine, dogovore o krmljenju in medicinska opozorila. Vsak zaposleni mora do tega dostopati brez iskanja.",
      cards: [
        {
          t: "Konji po lastniku",
          d: "Vsak lastnik vidi samo svojega/svoje konje.",
        },
        {
          t: "Navodila za oskrbo",
          d: "Vidna po konju za hlev.",
        },
        {
          t: "Skupna agenda",
          d: "Kovač, veterinar in tekmovanja v enem pogledu.",
        },
        {
          t: "Seznam nalog",
          d: "Dodeljevanje zaposlenim s potrditvijo.",
        },
        {
          t: "Dostop za lastnike",
          d: "Stranke vidijo svojega konja v lastni aplikaciji.",
        },
        {
          t: "Nujni stiki",
          d: "Vedno dostopni v stresnih situacijah v hlevu.",
        },
      ],
      ctaLabel: "Oglejte si modul za jahalnico",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "Od WhatsApp, Excel in bele table do EquiSight.",
      lead: "Konkretno: tako se spremeni vaše vsakodnevno upravljanje konj.",
      rows: [
        {
          before: "WhatsApp skupineа",
          after: "Strukturirani zapiski po konju",
        },
        {
          before: "Excel tabele",
          after: "Živa konjska mapa z zgodovino",
        },
        {
          before: "Bela tabla v hlevu",
          after: "Skupno načrtovanje na telefonu",
        },
        {
          before: "Ločene fotografije na fotoaparatu",
          after: "Mediji povezani z vašim konjem",
        },
        {
          before: "Ustni dogovori",
          after: "Naloge in opomniki s potrditvijo",
        },
        {
          before: "Izgubljen papirnati potni list",
          after: "Dokumenti vedno pri roki",
        },
      ],
    },
    helper: {
      title: "Katera aplikacija za upravljanje konj ustreza vam?",
      lead: "Odgovorite na teh 5 vprašanj in dobili boste pošteno priporočilo — tudi če to ni vedno EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Imate enega ali več konj?",
          options: [
            {
              label: "Enega konja",
              score: 1,
            },
            {
              label: "2–5 konj",
              score: 2,
            },
            {
              label: "Več kot 5 konj",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Upravljate konje strank ali tretjih oseb?",
          options: [
            {
              label: "Ne, samo svoje konje",
              score: 0,
            },
            {
              label: "Včasih — za družino ali znance",
              score: 1,
            },
            {
              label: "Da, profesionalno (hlev / jahalnica)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Želite spremljati rejo in brejost?",
          options: [
            {
              label: "Ni relevantno",
              score: 0,
            },
            {
              label: "Včasih — občasna reja",
              score: 1,
            },
            {
              label: "Da, sem (ali bom postal/a) rejec/rejka",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Sodelujete s trenerjem, skrbnikom ali strokovnjakom?",
          options: [
            {
              label: "Ne, vse delam sam/a",
              score: 0,
            },
            {
              label: "Da, z eno osebo",
              score: 1,
            },
            {
              label: "Da, z več osebami",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Želite samo beležiti ali tudi pridobivati vpoglede?",
          options: [
            {
              label: "Samo beležiti",
              score: 1,
            },
            {
              label: "Beležiti in načrtovati",
              score: 2,
            },
            {
              label: "Beležiti, načrtovati in pridobivati vpoglede",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Preprost dnevnik zadostuje — in raste z vami.",
          body: "Za enega konja brez skupne oskrbe je vsaka aplikacija za upravljanje konj primerna. EquiSight začne brezplačno z 1 konjem, torej brez tveganja. Če boste kasneje želeli dodati več konj, trenerja ali rejo, je vse že vključeno.",
          cta: "Začnite brezplačno z 1 konjem",
        },
        mid: {
          title: "EquiSight dobro ustreza vaši situaciji.",
          body: "Imate več potreb (več konj, sodelovanje ali vpogledi). Večina konkurentov pokriva 1–2 modula; EquiSight jih združuje v eni aplikaciji, brez potrebe po ločenih orodjih.",
          cta: "Oglejte si, kaj zmore EquiSight",
        },
        high: {
          title: "EquiSight je najbolj logična izbira.",
          body: "Vaša situacija združuje več konj, sodelovanje, rejo in/ali vpoglede. Prav tu EquiSight naredi razliko — nobenih razpršenih orodij, le ena konjska mapa za vse in vsakogar okoli konja.",
          cta: "Začnite brezplačno z EquiSight",
        },
      },
    },
    faqTitle: "Pogosta vprašanja o aplikacijah za upravljanje konj",
    faq: [
      {
        q: "Katera je najboljša aplikacija za upravljanje konj?",
        a: "Najboljša aplikacija za upravljanje konj je odvisna od vaše situacije. Za preprost dnevnik je primerno več aplikacij. Če želite združiti zdravje, trening, prehrano, dokumente, rejo, načrtovanje in sodelovanje, je EquiSight zgrajen kot popolna rešitev, kjer se vse zbira v eni mapi.",
      },
      {
        q: "Ali lahko upravljam več konj v eni aplikaciji?",
        a: "Da. Dobra aplikacija za upravljanje konj mora podpirati več konj, vključno z lastniki, skrbniki, rutinami, dokumenti, termini in opomniki po konju. EquiSight je zasnovan za to od prve vrstice kode — konji so individualne mape, ne vrstice na seznamu.",
      },
      {
        q: "Ali je EquiSight primeren tudi za rejce?",
        a: "Da. EquiSight je mogoče nastaviti s funkcijami za rejo, kot so cikel kobil, datum osemenitve, kontrola brejosti, podatki o žrebcih, rodovnik, pričakovani datum žrebitve in razvoj žrebet. To je natanko področje, kjer večina konkurenčnih aplikacij sploh ne deluje ali deluje le minimalno.",
      },
      {
        q: "Ali lahko delim podatke s svojim trenerjem ali kovačem?",
        a: "Da. Namen EquiSight je, da se ustrezne informacije varno delijo z ljudmi okoli konja — trenerjem, kovačem, zobozdravnikom, veterinarjem, fizioterapevtom, skrbnikom ali lastnikom. Vsaka oseba dobi le pravice, ki so potrebne za njeno vlogo.",
      },
      {
        q: "Zakaj ne bi preprosto uporabili WhatsApp ali Excel?",
        a: "WhatsApp in Excel delujeta, dokler je vse preprosto. Ko imate več konj, terminov, dokumentov, zdravljenj, lastnikov ali podatkov o reji, postane to nagnjeno k napakam: informacije se razpršijo, iskanje vzame čas in ustni dogovori izginejo. Aplikacija za upravljanje konj zbere vse skupaj po konju z avtomatskimi opomniki.",
      },
      {
        q: "Koliko stane EquiSight?",
        a: "Začnete lahko brezplačno z 1 konjem. Če želite upravljati več konj, aktivirati rejo ali dati dostop strokovnjakom, obstajajo ugodni Premium načrti. Oglejte si aktualne možnosti na strani s cenami.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Programska oprema za rejo konj: popolna primerjava 2026",
      description: "Primerjajte programsko opremo za rejo konj: ciklus kobil, brejost, izbor žrebca in žrebeta. Odkrijte, zakaj je EquiSight popolna aplikacija za rejo konj.",
      keywords: [
        "programska oprema za rejo konj",
        "aplikacija za ciklus kobil",
        "aplikacija za brejost kobil",
        "aplikacija za registracijo žrebet",
        "aplikacija za rodovnik konja",
        "načrtovanje parjenja konja",
        "aplikacija za izbor žrebca",
      ],
    },
    hero: {
      eyebrow: "Vodnik za izbiro · programska oprema za rejo",
      breadcrumbLabel: "Programska oprema za rejo",
      title: "Programska oprema za rejo konj: popolna primerjava za 2026.",
      intro: "Plemenita kobila si zasluži več kot splošno aplikacijo za upravljanje konj. Primerjajte funkcije reje najbolj znanih orodij, odkrijte, na kaj resnično morate biti pozorni, in zavestno izberite programsko opremo, ki ustreza vaši ergeli — veliki ali majhni.",
      pills: [
        {
          icon: "Baby",
          label: "Ciklus kobil",
        },
        {
          icon: "Heart",
          label: "Kontrola brejosti",
        },
        {
          icon: "Sparkles",
          label: "Razvoj žrebet",
        },
        {
          icon: "FileText",
          label: "Rodovnik",
        },
      ],
      ctas: [
        {
          label: "Začnite brezplačno z modulom za rejo",
          href: "#start",
          primary: true,
        },
        {
          label: "Na primerjalno tabelo",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Zakaj navadna aplikacija za upravljanje konj ne zadostuje za rejo.",
      lead: "Večina aplikacij za konjeniški šport je zasnovana za enega športnega ali rekreacijskega konja. Reja ima povsem drugačen ritem: pojatev, inseminacija, kontrola brejosti, ultrazvočni pregledi, koledar žrebet, rodovnik in prodaja. En Excel se po 2 sezonah zmede — pri več kobilah pa izgubite pregled.",
      items: [
        "Kdaj je bil zadnji ciklus Bonite?",
        "Kateri žrebec je načrtovan za parjenje v naslednji sezoni?",
        "Je že načrtovan ultrazvočni pregled po 21 dneh?",
        "Katera žrebeta iz leta 2024 so že prodana?",
        "Kje je rodovniški diagram do dedka po materini strani?",
        "Kje so vzorci DNA in podatki potnega lista?",
      ],
    },
    what: {
      title: "Kaj je programska oprema za rejo konj?",
      lead: "Programska oprema za rejo je specializirana evidenca za vsako kobilo in žrebca, skupaj s koledarjem rejskega leta, načrtovanjem brejosti, registracijo žrebet in prikazom rodovnika. Ni splošen dnevnik za konje, temveč orodje, ki razume rejski cikel: od prve pojatve do odstavitve.",
      targetGroupsTitle: "Za katero vrsto rejca je programska oprema za rejo namenjena?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Hobijski rejec (1–3 kobil)",
          body: "Eno ali dve parjenji na leto — pregled brez akrobacij z Excelom.",
        },
        {
          icon: "Building2",
          title: "Majhna ergela (4–10 kobil)",
          body: "Načrt rejskega leta s ciklusom, inseminacijo, kontrolami brejosti in dosjejem žrebeta.",
        },
        {
          icon: "Users",
          title: "Profesionalna ergela (10+)",
          body: "Več zaposlenih, izbor žrebca za vsako kobilo, prodaja in trženje.",
        },
        {
          icon: "Target",
          title: "Lastnik žrebca",
          body: "Zgodovina naročil, statistike semena in urnik za vsakega žrebca.",
        },
        {
          icon: "Heart",
          title: "Embriotransplantacija",
          body: "Donorska in sprejemna kobila kot povezan dosje, ET-koledar.",
        },
        {
          icon: "ClipboardList",
          title: "Vpis v rodovniško knjigo",
          body: "Vzorci DNA, dokumenti potnega lista in rodovniški podatki.",
        },
      ],
    },
    criteria: {
      title: "Kaj mora dobra programska oprema za rejo izpolnjevati?",
      lead: "Ni vsaka »funkcija reje« v aplikaciji za konje enaka. Pet ključnih področij, kjer rejci izgubijo največ časa — in kjer programska oprema resnično naredi razliko.",
      items: [
        {
          icon: "Calendar",
          title: "Ciklus kobil in pojatev",
          body: "Dnevni dnevnik, napovedno ovulacijo, sledenje ciklusu in samodejne opomnike.",
        },
        {
          icon: "Heart",
          title: "Inseminacija in kontrola brejosti",
          body: "Datumi parjenja in inseminacije, podatki o žrebcu, ultrazvok po 14, 21 in 60 dneh ter določitev spola.",
        },
        {
          icon: "Baby",
          title: "Razvoj žrebeta",
          body: "Podatki ob rojstvu, grafikon telesne mase, program razparazitenja, trenutek odstavitve, registracija potnega lista.",
        },
        {
          icon: "FileText",
          title: "Rodovnik in dokumenti",
          body: "Prikaz rodovnika do 4–5 generacij, DNA, številke potnih listov in status v rodovniški knjigi.",
        },
        {
          icon: "Target",
          title: "Izbor žrebca in ujemanje",
          body: "Filtriranje po disciplini, linijah, podatkih o žrebcu in preteklih uspehih — ne le po tem, kar lastnik žrebca promovira.",
        },
        {
          icon: "Share2",
          title: "Sodelovanje z veterinarjem/inseminatorjem",
          body: "Ultrazvočne slike, vzorci in statusi neposredno deljeni s prakso, ki dela z vašimi kobilami.",
        },
      ],
    },
    comparison: {
      title: "EquiSight v primerjavi z drugo programsko opremo za rejo.",
      lead: "Iskalni rezultati za programsko opremo za rejo pogosto prikazujejo splošne aplikacije za konje, ki rejo omenijo le v enem stavku. Pošteno primerjamo, katera orodja imajo resnično popoln rejski tok.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Brezplačen začetek",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Beleženje ciklusa kobil",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Datum inseminacije + žrebec",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ultrazvočni pregledi in kontrola brejosti",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Pričakovan datum rojstva žrebeta",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dosje žrebeta (teža/rast)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Rodovnik do 4–5 generacij",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Registracija DNA in potnega lista",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Izbor žrebca / ujemanje",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / embriotransplantacija",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Pregled več kobil hkrati",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobilna aplikacija (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Deljenje z veterinarjem",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrirano s splošnim dosjejem",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Prodaja in trženje žrebet",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Primerjava temelji na javno dostopnih funkcijah iz januarja 2026. EquineGenie je močan pri reji, a šibkejši pri mobilni uporabi in splošnem upravljanju konj. EquiSight združuje oboje.",
    },
    why: {
      title: "Zakaj EquiSight rejcem nudi drugačno storitev.",
      lead: "Mnogi rejci uporabljajo ločeno programsko opremo za rejo in ločeno aplikacijo za upravljanje konj. EquiSight združuje oboje — brez preklapljanja med aplikacijami ali dvojnega vnosa podatkov.",
      points: [
        {
          icon: "Heart",
          title: "Plemenita kobila ostane tudi navaden konj",
          body: "Plemenita kobila ima rejski dosje in navaden dosje konja — zdravje, cepljenja, podkovač. Ena aplikacija, vsi moduli.",
        },
        {
          icon: "Sparkles",
          title: "Napovedovalno namesto reaktivno",
          body: "Napoved ciklusa, opomniki za mejnike brejosti in koledar žrebet — samodejno na podlagi vaših podatkov.",
        },
        {
          icon: "Share2",
          title: "Vsi vpleteni v rejo",
          body: "Inseminator, lastnik žrebca, veterinar, kupec, rodovniška knjiga — vsem dostop s pravimi dovoljenji.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Po disciplini · od ciklusa do odstavitve",
      title: "Kaj vsebuje rejski dosje v EquiSight-u.",
      lead: "Za vsako kobilo dobite popoln rejski dosje, povezan z njenim rednim dosjejem konja.",
      items: [
        "Dnevni dnevnik ciklusa z napovedjo",
        "Inseminacija/parjenje + podatki o žrebcu",
        "Časovnica ultrazvočnih pregledov (14/21/60 dni + spol)",
        "Mejniki brejosti s samodejnimi opomniki",
        "Pričakovan datum rojstva in priprave",
        "Dosje žrebeta od rojstva naprej",
        "Rodovnik do dedka/babice s klikabilno navigacijo",
        "Vzorec DNA, potni list, status v rodovniški knjigi",
        "Prodajna cevovod z zainteresiranimi strankami",
        "Zgodovina izbora žrebca za vsako kobilo",
      ],
      ctaLabel: "Oglejte si modul za rejo",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Za celotno ergelo",
      title: "Pregled za več kobil in žrebcev.",
      lead: "Ko redite več kot 2–3 kobil, postane pregled vseh ciklusov in brejosti ključnega pomena.",
      cards: [
        {
          t: "Nadzorna plošča ciklusa",
          d: "Vse kobil skupaj, s fazo ciklusa in naslednjo akcijo.",
        },
        {
          t: "Cevovod brejosti",
          d: "Katere kobil so kje pri mejnikih brejosti?",
        },
        {
          t: "Koledar žrebet",
          d: "Pričakovani porodi po mesecih, z usklajeno logistiko.",
        },
        {
          t: "Portfelj žrebcev",
          d: "Lastni žrebci ali stalni inseminatorji z zgodovino naročil.",
        },
        {
          t: "Graf rodovnika",
          d: "Analiza prednikov čez več generacij in linij.",
        },
        {
          t: "Prodajna nadzorna plošča",
          d: "Katera žrebeta so prodana, rezervirana ali še na voljo.",
        },
      ],
    },
    beforeAfter: {
      title: "Od Excela in dnevnika k EquiSight reji.",
      lead: "Konkretno: tako se spremeni vaša sezona reje.",
      rows: [
        {
          before: "Ciklus v ločenem zapisu",
          after: "Dnevni dnevnik z napovedjo",
        },
        {
          before: "Ultrazvočne slike po WhatsAppu inseminatorju",
          after: "Deljeni dosje s fotografijami",
        },
        {
          before: "Datum brejosti v dnevniku",
          after: "Samodejni opomniki za mejnike",
        },
        {
          before: "Potni list žrebeta v predalu",
          after: "Dokument povezan s profilom žrebeta",
        },
        {
          before: "Rodovnik na papirju",
          after: "Klikabilen rodovnik do 4–5 generacij",
        },
        {
          before: "Prodajni oglas na Marktplaats",
          after: "Prodajni cevovod s seznamom zainteresiranih",
        },
      ],
    },
    helper: {
      title: "Katera programska oprema za rejo vam ustreza?",
      lead: "5 vprašanj za ugotovitev, ali potrebujete popolno aplikacijo za rejo ali zadostuje hobijsko orodje.",
      questions: [
        {
          id: "mares",
          q: "Koliko plemenitih kobil upravljate?",
          options: [
            {
              label: "1 kobila",
              score: 1,
            },
            {
              label: "2–5 kobil",
              score: 2,
            },
            {
              label: "Več kot 5 kobil",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Kako pogosto redite na leto?",
          options: [
            {
              label: "Občasno (vsake nekaj let)",
              score: 0,
            },
            {
              label: "Vsako leto 1–2 parjenji",
              score: 2,
            },
            {
              label: "Vsako leto 3+ parjenj",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Kako inseminirate/parite?",
          options: [
            {
              label: "Naravno parjenje",
              score: 1,
            },
            {
              label: "UI s svežim/ohlajenim semenom",
              score: 2,
            },
            {
              label: "ET ali zamrznjeno seme",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Ali sodelujete z veterinarjem/inseminatorjem?",
          options: [
            {
              label: "Ena stalna oseba",
              score: 1,
            },
            {
              label: "Več praks",
              score: 2,
            },
            {
              label: "Mednarodna mreža",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Kaj trenutno beležite?",
          options: [
            {
              label: "Excel ali papir",
              score: 1,
            },
            {
              label: "Splošna aplikacija za upravljanje konj",
              score: 2,
            },
            {
              label: "Nič strukturiranega",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Zadostuje hobijsko orodje ali Excel — a EquiSight je še vedno priročen.",
          body: "Za 1 kobilo z naravnim parjenjem vsake nekaj let je obsežen modul za rejo pretirano. EquiSight začnete brezplačno in modul za rejo aktivirate samo za leto, ko parite — brez obveznosti nadgradnje.",
          cta: "Začnite brezplačno",
        },
        mid: {
          title: "EquiSight reja je pravo orodje za vas.",
          body: "Imate več kobil ali več metod reje — za to splošne aplikacije za konje niso zasnovane. EquiSight združuje rejo in splošno nego, tako da ne preklapljate med dvema orodjema.",
          cta: "Oglejte si modul za rejo",
        },
        high: {
          title: "EquiSight je zgrajen za vašo ergelo.",
          body: "Več kobil, ET ali zamrznjeno seme, mednarodna ekipa — večina orodij temu ni kos. EquiSight se prilagaja do ravni ergele brez kopičenja dodatnih licenc.",
          cta: "Pogovorite se z nami o načrtu za ergelo",
        },
      },
    },
    faqTitle: "Pogosta vprašanja o programski opremi za rejo konj",
    faq: [
      {
        q: "Katera je najboljša programska oprema za rejo konj?",
        a: "Za 1 kobilo brez zapletenih metod reje zadostuje veliko orodij. Od 2–3 kobil naprej, pri uporabi UI ali ET ali pri sodelovanju z veterinarjem in rodovniško knjigo pa postane popoln modul za rejo ključnega pomena. EquiSight združuje rejo in splošno upravljanje konj v eni aplikaciji, tako da vam ni treba preklapljati.",
      },
      {
        q: "Katere funkcije reje resnično potrebujem?",
        a: "Minimalno: dnevnik ciklusa, podatki o inseminaciji/parjenju, mejniki kontrole brejosti in dosje žrebeta. Neobvezno, a zmogljivo: prikaz rodovnika, arhiv izbora žrebca, DNA/potni list in prodajni cevovod.",
      },
      {
        q: "Ali EquiSight zna napovedati ciklus kobile?",
        a: "Da. EquiSight uporablja prejšnje podatke o ciklusu za prikaz napovedane ovulacije, da načrtujete inseminacijo ali parjenje ob pravem trenutku — brez vsakodnevnega ugibanja.",
      },
      {
        q: "Ali EquiSight deluje tudi za embriotransplantacijo?",
        a: "Da. Donorska in sprejemna kobila dobita povezana dosje, ET-koledar in skupne mejnike s prakso. Tako ne izgubite časovnice v zahtevnem ET-postopku.",
      },
      {
        q: "Ali lahko uvozim obstoječe podatke o reji?",
        a: "Podatke o ciklusu, parjenjih in žrebetih lahko vnašate ročno ali v paketu prek CSV. Pri aktivnih ergelah pomagamo z enkratno selitvijo podatkov, če imate zbrane podatke za več sezon.",
      },
      {
        q: "Kako delim dosje s svojim veterinarjem ali inseminatorjem?",
        a: "Vsaki osebi dodelite dostop z vlogo: veterinar, inseminator, lastnik žrebca ali uradnik rodovniške knjige. Vsak vidi le informacije, ki jih potrebuje za svojo vlogo — popoln dostop ni potreben.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Programska oprema za jahalnico: popolna primerjava in vodič pri izbiri 2026",
      description: "Primerjajte programsko opremo za jahalnice za pouke, jahače, konje in administracijo. Odkrijte, katera aplikacija ustreza vaši jahalnici ali penzionu za konje.",
      keywords: [
        "programska oprema za jahalnico",
        "aplikacija za upravljanje hleva",
        "administrativna programska oprema za jahalnico",
        "načrtovanje pouka v jahalnici",
        "programska oprema za penzion za konje",
        "administracija jahačev",
        "administracija konj v jahalnici",
      ],
    },
    hero: {
      eyebrow: "Vodič pri izbiri · programska oprema za jahalnico",
      breadcrumbLabel: "Programska oprema za jahalnico",
      title: "Programska oprema za jahalnico: popoln vodič pri izbiri za jahalnice in penzionate za konje.",
      intro: "Načrtovanje pouka, administracija jahačev, upravljanje konj, fakturiranje in komunikacija — dobra programska oprema za jahalnico združi vse skupaj. Primerjajte najpogostejše možnosti in odkrijte, katera ustreza vašemu hlevu ali jahalnici.",
      pills: [
        {
          icon: "Calendar",
          label: "Načrtovanje pouka",
        },
        {
          icon: "Users",
          label: "Jahači in stranke",
        },
        {
          icon: "Heart",
          label: "Nega konj",
        },
        {
          icon: "CreditCard",
          label: "Fakturiranje",
        },
      ],
      ctas: [
        {
          label: "Zahtevajte predstavitev",
          href: "#start",
          primary: true,
        },
        {
          label: "Na primerjalno tabelo",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Zakaj razpršena orodja upočasnijo jahalnico.",
      lead: "Večina jahalnic deluje s krpanko: načrtovanje pouka na beli tabli, registracija jahačev v Excel, fakturiranje v ločenem orodju, nega konj prek WhatsApp in stik z lastniki prek zasebnih sporočil. V prometnem tednu nastanejo dvojne rezervacije, pozabljene fakture ali konji, ki ne vedo, kateri jahač jih dobi.",
      items: [
        "Kdo je zdaj pri pouku z Jasmino?",
        "Kateri jahač še ni plačal za marec?",
        "Kateri konj ta teden ne sme biti v uporabi?",
        "Kdo so nujni kontakti učencev?",
        "Ali je lastnik Zvezdice že prejel račun kovača?",
        "Kateri konj stoji v kateri boksi?",
      ],
    },
    what: {
      title: "Kaj je programska oprema za jahalnico?",
      lead: "Programska oprema za jahalnico združuje načrtovanje pouka, administracijo jahačev, upravljanje konj, fakturiranje in komunikacijo v enem orodju. Nobene akrobatike z Excelom ali kaosa z WhatsApp — le eno mesto, kjer jahalnica deluje in lastniki/jahači pregledujejo podatke.",
      targetGroupsTitle: "Za katero vrsto podjetja je programska oprema za jahalnico namenjena?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Majhna jahalnica (1–15 konj)",
          body: "Predvsem načrtovanje pouka in plačila — administracija brez glavobolov.",
        },
        {
          icon: "Users",
          title: "Srednje velika jahalnica (15–40 konj)",
          body: "Več inštruktorjev, načrtovanje pouka + razpored konj + administracija jahačev.",
        },
        {
          icon: "ClipboardList",
          title: "Velika jahalna in penzionu za konje (40+)",
          body: "Celotno poslovanje vključno s fakturiranjem, načrtovanjem prehrane in kovača.",
        },
        {
          icon: "Heart",
          title: "Penzion za konje",
          body: "Portal za lastnike, individualna navodila za nego, skupna agenda.",
        },
        {
          icon: "Target",
          title: "Trenažni hlev za skakače",
          body: "Načrtovanje tekmovanj, trening po konju, stik s strankami.",
        },
        {
          icon: "FileText",
          title: "Konjeniški podjetniki",
          body: "Kombinacija pouka + penziona + klinike + trgovine — vse iz enega sistema.",
        },
      ],
    },
    criteria: {
      title: "Kaj mora dobra programska oprema za jahalnico izpolnjevati?",
      lead: "Lepa aplikacija ne pomeni nič, če z njo vaši zaposleni ne želijo delati. Pet praktičnih meril, ki naredijo razliko med uspehom in frustracijo.",
      items: [
        {
          icon: "Calendar",
          title: "Načrtovanje pouka na več ravneh",
          body: "Začetniki/napredni, dresura/skoki, povezave konj in urniki inštruktorjev — vse vidno hkrati.",
        },
        {
          icon: "Users",
          title: "Administracija jahačev",
          body: "Profili, raven, naročnina, kartica ur in povezave z družinskimi člani za mladinske jahače.",
        },
        {
          icon: "Heart",
          title: "Razpored konj",
          body: "Kateri konj se kako pogosto uporablja, z obdobji počitka, poškodb in menstruacije.",
        },
        {
          icon: "CreditCard",
          title: "Fakturiranje in naročnine",
          body: "Mesečne naročnine, kartice ur, posamezni pouki in samodejni direktni bremenit.",
        },
        {
          icon: "Share2",
          title: "Portal za lastnike (penzion)",
          body: "Lastniki vidijo svojega konja v lastni aplikaciji — agenda, stroški, kovač in opombe brez klicanja.",
        },
        {
          icon: "Bell",
          title: "Komunikacija in opomniki",
          body: "Samodejni opomniki za pouk, obvestila o plačilih, najave kovača — brez pošiljanja sporočil.",
        },
      ],
    },
    comparison: {
      title: "EquiSight proti drugi programski opremi za jahalnice.",
      lead: "Mnoga orodja za jahalnice so močna pri načrtovanju pouka ali fakturiranju, a redko pri negi konj in komunikaciji z lastniki hkrati. Pošteno jih primerjamo.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Brezplačen začetek / preizkusno obdobje",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Načrtovanje pouka",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Več inštruktorjev",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Administracija jahačev",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Razpored konj",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Nega konj (cepljenje/kovač)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kartica ur / naročnina",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Spletna plačila",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Samodejno fakturiranje",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Portal za lastnike (penzion)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Integracija kovača/veterinarja",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Opomniki prek WhatsApp/SMS",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobilna aplikacija (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Načrtovanje tekmovanj",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Primerno za penzion za konje",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Primerjava na podlagi javno dostopnih funkcij januarja 2026. Stalmanager je močan pri administraciji, EquiSight se odlikuje z delovnim tokom penziona + nego konj + portalom za lastnike.",
    },
    why: {
      title: "Zakaj je EquiSight drugačen za jahalnice in penzionate za konje.",
      lead: "EquiSight gre dlje od načrtovalnika pouka. Jahalnico vidimo kot celovito poslovanje: konji, ljudje, komunikacija in finance — vse med seboj odvisno.",
      points: [
        {
          icon: "Heart",
          title: "Konj v središču, ne agenda",
          body: "Vsak konj ima svojo kartoteko. Vključitev v pouk, zdravje, kovač in tekmovanja v eni časovnici — ne 3 ločena orodja.",
        },
        {
          icon: "Share2",
          title: "Lastniki pregledujejo brez klicanja",
          body: "Lastniki penzionta imajo lasten pogled: stroški, načrtovanje, fotografije in opombe — prihrani 5–10 telefonskih klicev na teden.",
        },
        {
          icon: "Bell",
          title: "Samodejna komunikacija",
          body: "Opomnik za pouk, opomnik za cepljenje, račun — samodejno, prek aplikacije/e-pošte/SMS. Konec skupinskih sporočil prek WhatsApp.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Za penzion za konje",
      title: "Kaj penzion za konje dobi z EquiSight.",
      lead: "Penzionati za konje imajo edinstvene izzive, ki jih navadna programska oprema za jahalnice ne reši.",
      cards: [
        {
          t: "Portal za lastnike",
          d: "Vsak lastnik vidi le svojega konja (konje), agendo in stroške.",
        },
        {
          t: "Navodila za nego po konju",
          d: "Krma, voluminozna krma, dodatki, urnik pokrivala — vidno za hlev.",
        },
        {
          t: "Skupna agenda",
          d: "Kovač, veterinar in obiski lastnikov v enem pogledu.",
        },
        {
          t: "Stroški porabe po konju",
          d: "Steljna, krma, močna krma zaračunana po lastniku.",
        },
        {
          t: "Nujni kontakti konja",
          d: "Lastnik + veterinar + kovač vedno dostopni za hlev.",
        },
        {
          t: "Upravljanje pašništva",
          d: "Kateri konji gredo na pašo, na počitek ali v rehabilitacijo?",
        },
      ],
    },
    beforeAfter: {
      title: "Od bele table + Excela do EquiSight.",
      lead: "Konkretno: tako se spremeni delovni teden v jahalnici.",
      rows: [
        {
          before: "Bela tabla z načrtom pouka",
          after: "Živo načrtovanje po inštruktorju",
        },
        {
          before: "Excel z jahači + opombami o pouku",
          after: "CRM strank z zgodovino pouka",
        },
        {
          before: "WhatsApp lastnikom",
          after: "Portal za lastnike za njihovega konja",
        },
        {
          before: "Mesečni direktni bremenitvi ročno",
          after: "Samodejno fakturiranje + iDEAL",
        },
        {
          before: "Nega konj na papirni oglasni deski",
          after: "Navodila za nego po konju, deljena",
        },
        {
          before: "Ustni dogovor s kovačem",
          after: "Načrtovanje kovača s potrdili",
        },
      ],
    },
    helper: {
      title: "Katera programska oprema za jahalnico ustreza vam?",
      lead: "5 vprašanj, da ugotovite, ali je EquiSight prava platforma za vašo jahalnico ali penzion za konje.",
      questions: [
        {
          id: "size",
          q: "Koliko konj imate v svojem podjetju?",
          options: [
            {
              label: "Manj kot 10",
              score: 1,
            },
            {
              label: "10–30",
              score: 2,
            },
            {
              label: "Več kot 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Katera je vaša glavna dejavnost?",
          options: [
            {
              label: "Predvsem poučevanje",
              score: 1,
            },
            {
              label: "Penzion za konje",
              score: 3,
            },
            {
              label: "Kombinacija pouka + penziona",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "S koliko inštruktorji delate?",
          options: [
            {
              label: "Samo jaz",
              score: 1,
            },
            {
              label: "2–3 inštruktorji",
              score: 2,
            },
            {
              label: "4 ali več",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Kako trenutno urejate fakturiranje?",
          options: [
            {
              label: "Ročno (Word/Excel)",
              score: 3,
            },
            {
              label: "Ločen računovodski program",
              score: 2,
            },
            {
              label: "Vgrajeno v orodje za pouk",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Kako komunicirate z lastniki?",
          options: [
            {
              label: "Osebno / WhatsApp",
              score: 3,
            },
            {
              label: "E-pošta + WhatsApp",
              score: 2,
            },
            {
              label: "Portal za lastnike v orodju",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Enostavno orodje ali Excel za zdaj zadostuje — a EquiSight raste z vami.",
          body: "Za majhno poučevalno podjetje z enim inštruktorjem in malo penziona obsežen paket ni takoj potreben. EquiSight se začne brezplačno in raste skupaj z vašo jahalnico — brez bolečin pri selitvi čez nekaj let.",
          cta: "Začnite brezplačno",
        },
        mid: {
          title: "EquiSight je logična nadgradnja za vašo jahalnico.",
          body: "Več inštruktorjev, kombinacija pouka in penziona ali fakturiranje, ki je trenutno ločeno — EquiSight to združi v en delovni tok. Zlasti portal za lastnike prihrani veliko ad-hoc komunikacije.",
          cta: "Zahtevajte predstavitev",
        },
        high: {
          title: "EquiSight je zgrajen za vaše merilo.",
          body: "Penzion za konje + pouk + več inštruktorjev je natanko tam, kjer se EquiSight razlikuje od klasičnih orodij za jahalnice. Portal za lastnike in integracija nege konj tedensko prihranita ure administracije in komunikacije.",
          cta: "Načrtujte predstavitev za vaš hlev",
        },
      },
    },
    faqTitle: "Pogosto zastavljena vprašanja o programski opremi za jahalnice",
    faq: [
      {
        q: "Katera je najboljša programska oprema za jahalnico?",
        a: "Za čisto načrtovanje pouka obstaja več dobrih možnosti. Ko potrebujete penzion za konje, več inštruktorjev ali sledenje negi konj, postane EquiSight popolna rešitev — brez žongliranja z orodji, vse na enem mestu.",
      },
      {
        q: "Ali lahko uvozim obstoječe stranke in ure pouka?",
        a: "Da. Podatke o strankah in urnike pouka lahko uvozite prek CSV. Aktivnim jahalnicam pomagamo z enkratno selitvijo, da vam ni treba ročno vnašati 200 jahačev.",
      },
      {
        q: "Ali deluje tudi za penzion brez pouka?",
        a: "Da. Način penziona izklopi pouke in se osredotoči na portal za lastnike, krmo/nego, načrtovanje kovača in zaračunavanje stroškov po konju.",
      },
      {
        q: "Ali se jahači lahko sami vpišejo in plačajo?",
        a: "Da. Jahači si prek lastnega računa ogledajo, kateri pouki so odprti, se vpišejo, plačajo šolnino z iDEAL in kupijo kartice ur.",
      },
      {
        q: "Kako je z zasebnostjo podatkov o konjih in lastnikih?",
        a: "Vsaka oseba ima vlogo (lastnik, jahač, inštruktor, zaposleni). Glede na vlogo vidite le tisto, kar potrebujete. Lastniki vidijo le svojega konja, jahači le lastne pouke.",
      },
      {
        q: "Ali se EquiSight lahko poveže z mojo računovodsko programsko opremo?",
        a: "Da, na voljo so povezave z Exact, Moneybird in e-Boekhouden. Računi se nato samodejno prenesejo v vaše računovodstvo.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Aplikacija za trenerje konj: primerjava in vodič za izbiro za trenerje 2026",
      description: "Primerjajte aplikacije za trenerje konj in jahačev: dnevnik treninga, video, cilji, analiza protokola in upravljanje strank. Poiščite pravo orodje za trenerje.",
      keywords: [
        "aplikacija za trenerje konj",
        "aplikacija za inštruktorje",
        "aplikacija za trening konj",
        "aplikacija za coaching jahačev",
        "dnevnik treninga konja",
        "analiza dresurnega protokola",
        "programska oprema za trenerje konj",
      ],
    },
    hero: {
      eyebrow: "Vodič za izbiro · programska oprema za trenerje",
      breadcrumbLabel: "Aplikacija za trenerje",
      title: "Aplikacija za trenerje konj: popoln vodič za izbiro za inštruktorje in trenerje.",
      intro: "Trener ali inštruktor žonglira s kombinacijami, urami, videoposnetki, cilji in tekmovanji. Primerjajte najboljše aplikacije za trenerje konj in izberite platformo, ki bo rasla skupaj z vašim coachingom tudi v letu 2026.",
      pills: [
        {
          icon: "Target",
          label: "Cilji in načrtovanje",
        },
        {
          icon: "Video",
          label: "Video analiza",
        },
        {
          icon: "TrendingUp",
          label: "Napredek",
        },
        {
          icon: "Users",
          label: "Stranke/kombinacije",
        },
      ],
      ctas: [
        {
          label: "Začnite brezplačno kot trener",
          href: "#start",
          primary: true,
        },
        {
          label: "Na primerjalno tabelo",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Zakaj WhatsApp coaching trenerjem stoji na poti.",
      lead: "Večina trenerjev dela z ločenimi orodji: WhatsApp za komunikacijo, beležnica za ure, YouTube ali WeTransfer za videoposnetke in Excel za rezultate tekmovanj. Pri 5 jahačih deluje. Pri 20 jahačih se informacije izgubijo, pozabite na cilje in izgubite pregled nad individualnim napredkom.",
      items: [
        "Kje je cilj Anouk za to sezono?",
        "Kateri video sem prejšnji mesec poslal Bramu?",
        "Je Lara videla analizo protokola svojega zadnjega tekmovanja?",
        "Katera kombinacija trenira koliko krat na teden?",
        "Je lastnik Stardusta prebral moja navodila za trening?",
        "Kdaj sem nazadnje dal povratne informacije o nihajočem impulzu?",
      ],
    },
    what: {
      title: "Kaj je aplikacija za trenerje konj in jahačev?",
      lead: "Aplikacija za trenerje združuje coaching CRM (kombinacije, ure, cilji), dnevnik treninga za vsakega konja, video povratne informacije, načrtovanje tekmovanj in analizo protokola. Nič več ločenega WhatsAppa/YouTuba/Excela, temveč ena platforma, kjer trener in jahač sodelujeta skupaj.",
      targetGroupsTitle: "Za kateri tip trenerja je to namenjeno?",
      targetGroups: [
        {
          icon: "Target",
          title: "Dresurni inštruktor",
          body: "Pregledajte protokol, povežite komentarje sodnikov s cilji treninga, opazujte napredek.",
        },
        {
          icon: "Activity",
          title: "Trener preskakovanja ovir",
          body: "Načrtovanje prog, povratne informacije po rundah, upravljanje višin za vsakega konja.",
        },
        {
          icon: "Award",
          title: "Eventing trener",
          body: "Tri discipline, trije načrti — vse vidno hkrati.",
        },
        {
          icon: "TrendingUp",
          title: "Trener zmogljivosti (šport)",
          body: "Sledenje EPI, tekmovanja, cilji — za vrhunske športnike in njihove ekipe.",
        },
        {
          icon: "Users",
          title: "Inštruktor v jahalni šoli",
          body: "Skupinske ure + individualni coaching v eni aplikaciji.",
        },
        {
          icon: "Heart",
          title: "Rekreacijski trener",
          body: "Hipoterapija, začetniki, lastniki z enim konjem.",
        },
      ],
    },
    criteria: {
      title: "Kaj mora dobra aplikacija za trenerje izpolnjevati?",
      lead: "Treniranje je človeško delo, toda pravo orodje vas naredi 30–50 % učinkovitejše in pomaga jahačem napredovati tudi med urami.",
      items: [
        {
          icon: "Users",
          title: "Upravljanje kombinacij",
          body: "Konj + jahač kot ena enota, z nivojem, cilji, napredkom in zgodovino.",
        },
        {
          icon: "ClipboardList",
          title: "Opombe ur in cilji",
          body: "Za vsako uro opomba s točkami fokusa, povezana z dolgoročnimi cilji.",
        },
        {
          icon: "Video",
          title: "Video povratne informacije",
          body: "Naložite video, označite trenutke, dodajte govorjene ali pisne povratne informacije.",
        },
        {
          icon: "Target",
          title: "Tekmovanje in analiza protokola",
          body: "Pregledajte protokole (KNHS/FEI), oglejte si ocene po elementih, komentarje sodnikov in trende.",
        },
        {
          icon: "Calendar",
          title: "Načrtovanje in kartice ur",
          body: "Urnik, plačila, naročnine in samodejni opomniki.",
        },
        {
          icon: "Share2",
          title: "Komunikacija z jahačem",
          body: "Jahač vidi svojo stran z urami, videoposnetki, cilji in povratnimi informacijami.",
        },
      ],
    },
    comparison: {
      title: "EquiSight v primerjavi z drugimi aplikacijami za trenerje.",
      lead: "Nekatera orodja za trenerje se osredotočajo na nadomestilo WhatsAppa, druga na analizo protokola. EquiSight združuje oboje z resničnim dosjejem konja — tako da jahač napreduje tudi med urami.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Brezplačen začetek",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Upravljanje kombinacij",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Opombe ur in povratne informacije",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dolgoročni cilji",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Nalaganje videa + povratne informacije",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Skeniranje protokola KNHS/FEI",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (indeks zmogljivosti)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Tekmovalni koledar",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Portal za jahača",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Kartica ur / naročnina",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Spletna plačila",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrirani dosje konja",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Vidni kovač/veterinar",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Za inštruktorja IN jahača",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Več konj na jahača",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Primerjava na podlagi javno dostopnih funkcij v januarju 2026. EquiSight je edinstven po analizi protokola + EPI in to združuje s splošnim upravljanjem konj.",
    },
    why: {
      title: "Zakaj EquiSight ponuja drugačno izkušnjo za trenerje.",
      lead: "Večina orodij za trenerje se konča, ko se ura zaključi. EquiSight nadaljuje — v dosjeju konja, v analizi tekmovanj, v sodelovanju z veterinarjem in lastnikom.",
      points: [
        {
          icon: "TrendingUp",
          title: "Skeniranje protokola → cilj treninga",
          body: "Skenirajte protokol KNHS in takoj vidite, kateri elementi zahtevajo pozornost. Cilji se samodejno izpostavijo.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach krepi vaše oko",
          body: "Podatki iz več ur, tekmovanj in protokolov razkrijejo vzorce, ki jih ne morete hraniti v glavi.",
        },
        {
          icon: "Share2",
          title: "Integrirano s konjem",
          body: "Trener vidi zgodovino cepljenj, kovača in poškodb konja — ne načrtujte treninga med okrevanjem.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Za dresuro in preskakovanje ovir",
      title: "Kaj vsebuje coaching dosje v EquiSight.",
      lead: "Za vsako kombinacijo dobite coaching tok, ki vse drži skupaj — ne izgubljajte več stvari v WhatsAppu.",
      items: [
        "Opombe ur s točkami fokusa za vsako sejo",
        "Dolgoročni cilji + mejniki",
        "Nalaganje videa s komentarji na časovni kodi",
        "Skeniranje protokola KNHS/FEI z ocenami",
        "Komentarji sodnikov povezani s treningom",
        "Rezultati tekmovanj in trend EPI",
        "Stik s stranko in zgodovina ur",
        "Kartica ur / naročnina / računi",
        "Graf napredka po disciplini",
        "Skupni dostop z lastnikom konja",
      ],
      ctaLabel: "Oglejte si modul za trenerje",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "Od WhatsAppa + YouTuba do EquiSight Trainer.",
      lead: "Konkretno: tako se spremeni vaš coaching potek dela.",
      rows: [
        {
          before: "WhatsApp z ločenimi video linki",
          after: "Video s povratnimi informacijami na časovni kodi v dosjeju",
        },
        {
          before: "Beležnica za vsakega jahača",
          after: "Coaching dnevnik s cilji + zgodovino",
        },
        {
          before: "Excel z rezultati tekmovanj",
          after: "Graf EPI + analiza protokola",
        },
        {
          before: "Ustni cilji",
          after: "Mejniki z indikatorjem napredka",
        },
        {
          before: "Ločeno orodje za fakturiranje",
          after: "Ure + iDEAL + naročnina v aplikaciji",
        },
        {
          before: "E-pošta lastniku o napredku",
          after: "Lastnik sledi v svojem pogledu",
        },
      ],
    },
    helper: {
      title: "Katera aplikacija za trenerje ustreza vam?",
      lead: "5 vprašanj, da ugotovite, ali specializirano orodje za coaching prinaša dodano vrednost za vašo prakso.",
      questions: [
        {
          id: "clients",
          q: "Koliko aktivnih kombinacij trenirate?",
          options: [
            {
              label: "Manj kot 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "Več kot 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Katera je vaša glavna disciplina?",
          options: [
            {
              label: "Dresura",
              score: 3,
            },
            {
              label: "Preskakovanje ovir",
              score: 2,
            },
            {
              label: "Rekreacija / razno",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Ali pri coachingu uporabljate video?",
          options: [
            {
              label: "Redko",
              score: 0,
            },
            {
              label: "Včasih (ročno)",
              score: 2,
            },
            {
              label: "Pogosto — sistematično",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Ali trenirate tekmovalne jahače?",
          options: [
            {
              label: "Ne, rekreativne",
              score: 0,
            },
            {
              label: "Včasih tekmovanja",
              score: 2,
            },
            {
              label: "Veliko — startne kartice so ključne",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Ali želite meriti svoj coaching?",
          options: [
            {
              label: "Ne, intuicija zadostuje",
              score: 0,
            },
            {
              label: "Da, a nimam časa",
              score: 2,
            },
            {
              label: "Da — coaching na podlagi podatkov",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Preprosto orodje ali celo WhatsApp zadostuje — za zdaj.",
          body: "Za manj kot 5 jahačev brez veliko videa ali tekmovanj je coaching aplikacija pretiravanj. EquiSight se začne brezplačno, zato ga lahko preizkusite, ko vaša praksa raste.",
          cta: "Začnite brezplačno",
        },
        mid: {
          title: "EquiSight Trainer vas naredi sistematično učinkovitejše.",
          body: "S 5–15 kombinacijami vsak mesec izgubite ure na WhatsAppu in ločenih videoposnetkih. EquiSight vse združi, samodejno skenira protokole in poskrbi, da jahači lahko vedno znova vidijo svoje povratne informacije.",
          cta: "Preizkusite modul Trainer",
        },
        high: {
          title: "EquiSight je zgrajen za vaše obseg coachinga.",
          body: "Veliko jahačev, video, tekmovanja in coaching na podlagi podatkov: točno tu se EquiSight razlikuje. EPI + skeniranje protokola + dosje konja vam dajejo prednost, ki je konkurenti nimajo.",
          cta: "Načrtujte demo za vašo coaching prakso",
        },
      },
    },
    faqTitle: "Pogosta vprašanja o aplikacijah za trenerje",
    faq: [
      {
        q: "Katera je najboljša aplikacija za trenerje konj in jahačev?",
        a: "Za čisto komunikacijo zadostuje veliko orodij (celo WhatsApp). Za cilje, video analizo, skeniranje protokola, sledenje tekmovanjem in upravljanje strank v enem orodju je EquiSight najpopolnejša rešitev — zlasti ker spremlja tudi samega konja, ne samo kombinacije.",
      },
      {
        q: "Ali EquiSight samodejno bere tekmovalne protokole?",
        a: "Da. Naložite protokol KNHS ali FEI in EquiSight izvleče ocene po elementih, komentarje sodnikov ter to poveže s kombinacijo. Trende vidite čez več tekmovanj.",
      },
      {
        q: "Kaj je EPI (Equestrian Performance Index)?",
        a: "EPI je EquiSight ocena, ki pretvori več tekmovalnih rezultatov v primerljiv indeks zmogljivosti. Tako vidite resnični napredek skozi različne razrede in sodnike.",
      },
      {
        q: "Ali lahko jahači sami rezervirajo in plačajo ure?",
        a: "Da. Jahači se prijavijo, vidijo razpoložljive termine, kupijo kartice ur in plačajo prek iDEAL. Vi odločate, kaj želite ponuditi.",
      },
      {
        q: "Ali deluje tudi za inštruktorja, ki dela pri jahalni šoli?",
        a: "Da. Kot samostojni trener z lastnimi strankami lahko delate brez vezave na račun jahalne šole. Stranke vam plačajo neposredno.",
      },
      {
        q: "Ali lahko prenesem obstoječe videoposnetke in opombe?",
        a: "Videoposnetke lahko naložite po kombinacijah ali z orodjem za skupinsko nalaganje. Uvoz opomb prek CSV. Aktivnim trenerjem pomagamo z enkratno selitvijo.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Vodniki in pomočniki pri izbiri programske opreme za upravljanje konj | EquiSight",
      description: "Vsi vodniki EquiSight na enem mestu: primerjave programske opreme za upravljanje konj, rejstvo, jahalnice in trenerje ter pomočniki pri izbiri za leto 2026.",
      keywords: [
        "vodniki za konjsko programsko opremo",
        "pomočnik pri izbiri upravljanja konj",
        "primerjava programske opreme za rejstvo",
        "vodnik za programsko opremo jahalnice",
        "primerjava aplikacij za trenerje",
      ],
    },
    hub: {
      eyebrow: "Vozlišče · vodniki",
      breadcrumbLabel: "Vodniki",
      title: "Štirje celoviti vodniki za izbiro prave programske opreme za konje.",
      intro: "Za vsako ciljno skupino poglobljen pomočnik pri izbiri: primerjalne tabele, merila, primeri in interaktivni kviz. Kliknite na vodnik, ki ustreza vaši situaciji, ali najprej raziščite poglobljene članke pod vsakim sklopom.",
      stats: {
        guides: "4 pomočniki pri izbiri",
        articles: "15 poglobljenih člankov",
        fair: "Poštena primerjava",
      },
      readMoreCta: "Preberite celoten vodnik",
      relatedHeading: "Poglobljeni članki",
      articlesCountSingular: "{{count}} poglobljen članek",
      articlesCountPlural: "{{count}} poglobljenih člankov",
      articlesCountAria: "Število člankov v sklopu",
      lastUpdatedPrefix: "Posodobljeno",
      lastUpdatedAria: "Datum zadnje posodobitve tega sklopa",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Pomočnik pri izbiri aplikacije za upravljanje konj",
        blurb: "Primerjajte najpopularnejše aplikacije za upravljanje konj in odkrijte, katera ustreza lastniku, hlevu ali rejstvu. Vključno s pošteno primerjalno tabelo in pomočnikom s 5 vprašanji.",
        audience: "Za lastnike, hlevske oskrbnike in vse ljubitelje konj, ki iščejo pregled.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Primerjava programske opreme za rejstvo",
        blurb: "Od kobile ciklusa do razvoja žrebet: oglejte si, katera programska oprema za rejstvo resnično deluje za vaše število kobil, metodo reje in zahteve matične knjige.",
        audience: "Za (hobi) rejce, ergele in lastnike žrebcev.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Pomočnik pri izbiri programske opreme za jahalnico",
        blurb: "Načrtovanje pouka, administracija jahačev, portal za lastnike in fakturiranje — vse v enem orodju. Primerjajte možnosti za jahalnice in pokojninske hleve v letu 2026.",
        audience: "Za jahalnice, pokojninske hleve in jahalne podjetja.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Pomočnik pri izbiri aplikacije za trenerje",
        blurb: "CRM za coaching, video povratne informacije, skeniranje protokolov KNHS in cilji na par. Katera trenerska aplikacija ustreza vaši coaching praksi?",
        audience: "Za inštruktorje, trenerje in coache.",
      },
    ],
    closing: {
      eyebrow: "Zakaj ti vodniki",
      title: "Poštena primerjava, ne le cen.",
      body1: "Mnoge \"primerjalne strani\" so prikrito oglaševanje. Naši vodniki postavljajo funkcije, ciljno skupino in konkurente drug ob drugega, kot bi to storila neodvisna informacijska vir. EquiSight se seveda izkaže kot celovita rešitev, a preberete tudi pošteno, kje so druge aplikacije močnejše.",
      body2: "Poglobljeni članki pod vsakim vodnikom odgovarjajo na konkretna vprašanja, ki izhajajo iz izbire: \"Kdaj prva ehografija po inseminaciji\", \"Kako avtomatiziram fakturiranje jahalnice\", \"Kako analiziram tekmovalni protokol\". Brez marketinškega napihovančka, le praksa.",
    },
    hubName: "EquiSight Vodniki",
  },
  ui: {
    sectionEyebrows: {
      pains: "Zakaj je to boleče",
      basics: "Osnove",
      criteria: "Kaj naredi rešitev dobro?",
      comparison: "Poštena primerjava",
      why: "Razlika",
      beforeAfter: "Od razdrobljenosti do pregleda",
      helper: "5 vprašanj",
    },
    table: {
      feature: "Funkcija",
      today: "Danes",
      withEquisight: "Z EquiSight",
    },
    helper: {
      questionLabel: "Vprašanje {{current}} od {{total}}",
      answerPrompt: "Odgovorite na {{count}} preostalo vprašanje in si oglejte priporočilo.",
      answerPromptPlural: "Odgovorite na {{count}} preostala vprašanja in si oglejte priporočilo.",
      resultEyebrow: "Vaš rezultat",
    },
    targetGroupsFallback: "Za koga je to namenjeno?",
    faqTitleFallback: "Pogosto zastavljena vprašanja",
  },
};

export default CORNERSTONES;
